import TranslationListItemRequest from "../translation/TranslationListItemRequest";

export default class LookupListItemRequest{
    constructor(
        public lookupId?:number,
        public parentLookupId?:number|null,
        public code:string="",
        public name:string="", 
        public lookupTypeId:number=0,
        public isAdded:boolean=false,
        public isUpdated:boolean=false,
        public isDeleted:boolean=false,
        public translations:Array<TranslationListItemRequest>=[]
    ){
    }    
}
